import moment from 'moment';
import Tag from '../../../components/Display/Tag';
import { getImage } from '../../../utils/imageHelper';
import { getConstant } from '../../../utils/constants';
import styles from "../cards.module.scss"
function NewsItem({ news, handleClickNews, scope, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickNews}>
      <img
        className={styles.projectImage}
        src={news.image ? news.image.file : getImage('img-ph.png')}
        alt={news.image ? news.image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{news.title}</p>
          <span className={styles.subtitle}>
            {moment(news.publication_date).format('LL')}
          </span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant(`${scope}.availableNewsTypes`, news.type).label,
              bgColor: 'bg-sky-950'
            }}
          />
          <Tag
            tag={{
              label: news.source_label ? 'Externe' : 'Interne',
              bgColor: 'bg-purple-700'
            }}
          />
        </div>
      </div>
    </div >
  );
}

export default NewsItem;
